module.exports = __webpack_public_path__ + "img/touping-people.3333909f.png";